import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import {
  AuthenticationEntity,
  SendVerificationPayload,
  ShortUrl,
  VerificationPayload,
} from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AuthVerifyApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  /**
   * check with the api the verification code
   * @param payload
   * @returns Observable<AuthenticationEntity>
   */
  verify(urlName: string, payload: VerificationPayload = {}): Observable<AuthenticationEntity> {
    const url = `auctions/${urlName}/verify/`
    return this.post<AuthenticationEntity>(url, payload)
  }

  /**
   * Verifies the phone number
   * @param token
   * @returns Observable<void>
   */
  verifyNotification(urlName: string, token: string): Observable<AuthenticationEntity> {
    const payload = { verification_token: token }
    const url = `auctions/${urlName}/verify-notification/`
    return this.post<AuthenticationEntity>(url, payload)
  }

  /**
   *
   * @param code
   * @returns The response for the short code from the API
   *  The response returns an object in the form of {actual_url: string, token?: string}
   */
  verifyShortCode(code: string): Observable<ShortUrl> {
    return this.http.get<ShortUrl>(`${this.appConfig.baseApiUrl}s/${code}/`, { withCredentials: true })
  }

  /**
   * Resends verification email or sms
   * @param uuid
   * @returns Observable<void>
   */
  sendVerification(urlName: string, uuid: string, payload: SendVerificationPayload = {}): Observable<void> {
    const url = `auctions/${urlName}/profiles/${uuid}/send-verification/`
    return this.post<void>(url, payload)
  }
}
